import { render } from "./ModalCashfunction.vue?vue&type=template&id=d9cbf93a"
import script from "./ModalCashfunction.vue?vue&type=script&lang=js"
export * from "./ModalCashfunction.vue?vue&type=script&lang=js"

import exportComponent from "/home/melvin/Workspace/Sjef.app/frontend/pos.sjef.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__